import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=bde1c824&scoped=true&"
import script from "./cart.vue?vue&type=script&lang=js&"
export * from "./cart.vue?vue&type=script&lang=js&"
import style0 from "./cart.vue?vue&type=style&index=0&id=bde1c824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde1c824",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartItem: require('/vercel/path0/components/cart/CartItem.vue').default,PaymentIcons: require('/vercel/path0/components/cart/PaymentIcons.vue').default,CartDetails: require('/vercel/path0/components/cart/CartDetails.vue').default,Card: require('/vercel/path0/components/general/Card.vue').default,VoucherForm: require('/vercel/path0/components/cart/VoucherForm.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default})
